import { ClockIcon } from '@heroicons/react/24/outline';
import type { TimeInputProps } from '@mantine/dates';
import { TimeInput } from '@mantine/dates';
import React, { forwardRef } from 'react';

import styles from './TimePicker.module.css';

export const LBTimePicker = forwardRef<
  React.ElementRef<typeof TimeInput>,
  TimeInputProps
>((props, ref) => (
  <TimeInput
    {...props}
    ref={ref}
    classNames={styles}
    rightSection={<ClockIcon height={18} width={18} />}
  />
));
